module.exports = __webpack_public_path__ + "70212d8192a3df8e97be61535f4667f3.png";